// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/sort.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/sort.proto.
 */
export const file_proto_model_core_sort = /*@__PURE__*/
  fileDesc("Chtwcm90by9tb2RlbC9jb3JlL3NvcnQucHJvdG8SBmNhcm1lbiJBCg5Tb3J0RGVzY3JpcHRvchINCgVmaWVsZBgBIAEoCRIgCgVvcmRlchgCIAEoDjIRLmNhcm1lbi5Tb3J0T3JkZXIqXAoJU29ydE9yZGVyEhoKFlNPUlRfT1JERVJfVU5TUEVDSUZJRUQQABIYChRTT1JUX09SREVSX0FTQ0VORElORxABEhkKFVNPUlRfT1JERVJfREVTQ0VORElORxACQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the message carmen.SortDescriptor.
 * Use `create(SortDescriptorSchema)` to create a new message.
 */
export const SortDescriptorSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_sort, 0);

/**
 * Describes the enum carmen.SortOrder.
 */
export const SortOrderSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_sort, 0);

/**
 * @generated from enum carmen.SortOrder
 */
export const SortOrder = /*@__PURE__*/
  tsEnum(SortOrderSchema);

